import * as THREE from 'three';

// Loads the wall of television sets tools/build-tvwall.mjs prepared - the
// off photo, the screen ids, the soft masks and the content coordinates -
// once, at startup, for visualizers/tvwall.js. Same preload/get shape as
// fountain-assets.js, and the same rule: the preload is a WIRING POINT every
// entry point must call (main, main-radio, main-embedded, play-boot,
// player-boot, the capture harness). Resolves to null when the textures are
// missing: tvwall.js then falls back to its procedural wall (it is never
// withdrawn).
const MANIFEST_URL = 'textures/tvwall.json';

let _assets = null;
let _promise = null;

function loadTexture(url, opts) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) {
      t.colorSpace = opts.srgb ? THREE.SRGBColorSpace : THREE.NoColorSpace;
      t.generateMipmaps = false;
      // the ids are read NEAREST (an id must never be interpolated); the
      // masks, reflections and uv keep the build's softened edges
      t.minFilter = opts.nearest ? THREE.NearestFilter : THREE.LinearFilter;
      t.magFilter = opts.nearest ? THREE.NearestFilter : THREE.LinearFilter;
      t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
      t.needsUpdate = true;
      resolve(t);
    }, undefined, function () { reject(new Error(url + ' failed to load')); });
  });
}

export function preloadTvwall() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('tvwall.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (m) {
      if (!m.off || !m.ids || !m.soft || !m.uv || !m.screens || !m.screens.length) throw new Error('tvwall.json incomplete (run tools/build-tvwall.mjs)');
      return Promise.all([
        loadTexture('textures/' + m.off, { srgb: true }),
        loadTexture('textures/' + m.ids, { nearest: true }),
        loadTexture('textures/' + m.soft, {}),
        loadTexture('textures/' + m.uv, {})
      ]).then(function (t) {
        _assets = { manifest: m, off: t[0], ids: t[1], soft: t[2], uv: t[3], screens: m.screens };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] tvwall assets unavailable, Tvwall falls back to its procedural wall', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getTvwall() {
  return _assets;
}
